import toast, { ToastOptions, Toaster } from "react-hot-toast"

export type AlertTypes = "success" | "error" | "loading"

export type AlertFnType = (type: AlertTypes, message: string, options?: ToastOptions) => void

const toastOptions: ToastOptions = {
	duration: 4000,
	position: "top-center",
	// Styling
	style: {},
	className: "",
	// Aria
	ariaProps: {
		role: "alert",
		"aria-live": "polite",
	},
}

const alert: AlertFnType = (type, message, options) => {
	switch (type) {
		case "success":
			toast.success(message, { ...toastOptions, ...options })
			break
		case "error":
			toast.error(message, {
				...toastOptions,
				...options,
				style: {
					border: "1px solid var(--warning)",
					padding: "10px 20px",
					color: "var(--warning)",
				},
				iconTheme: {
					primary: "var(--warning)",
					secondary: "var(--white)",
				},
			})
			break
		case "loading":
			toast.loading(message, { ...toastOptions, ...options })
			break
		// case "custom":
		// 	toast.custom(<div>Hello World</div>)
		// 	break
		default:
			break
	}
}

const useAlert = () => ({ alert })

export { useAlert, alert as triggerAlert, Toaster as AlertRoot }
